














































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RuleFilterVO } from "@/model/FlowDetailVO";
import { OperatorVO, ShowVO } from "@/model/FlowConfigVO";
import { getPickerOptions } from "@/services/common";
import store from "@/store";
import {getSuggestList, getContactPropertyDetail} from "@/services/api";

@Component
export default class FlowCondition extends Vue {
  // 无控件: NONE
  // 输入框控件: MULTI_INPUT | NUMBER_INPUT | INTERVAL
  // 日期控件: DATE_INTERVAL |  DATE |  RELATIVE_TIME

  @Prop({
    type: Object,
    default() {
      return undefined;
    },
  })
  filter!: RuleFilterVO;

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  fieldOptions!: ShowVO[];

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  typeOperators!: {
    [prop: string]: ShowVO[];
  };

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  operatorDetail!: {
    [prop: string]: OperatorVO;
  };

  @Prop({
    type: Boolean,
    default() {
      return false;
    },
  })
  deletable!: boolean;

  @Prop({
    type: Number,
    default() {
      return -Infinity;
    },
  })
  min!: number;

  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  status!: string;

  

  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  strictType!: string;

  @Prop({
    type: Boolean,
    default() {
      return false;
    },
  })
  defaultFill!: boolean;

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  filters!: RuleFilterVO[];


  public pickerOptions = getPickerOptions();
  public options = [];
  public filedDisable: boolean = false;
  newShowVO :ShowVO|{} = {}

  created() {
    if (this.defaultFill && !this.filter.field) {
      this.filter.field = this.fieldOptions[0]?.en||'';
    }
    this.fieldChange(this.filter.field, false);
    this.operateChange(this.filter, this.filter.operator, false);
    // 禁用状态判断
    // console.log(this.filter?.field, 'this.filter?.field');
    this.filedDisable = this.status === "RUN" || (
      this.status !== "INIT" &&
      typeof this.filter.id !== "undefined" &&
      !["PROPERTY_STRICT", "ACTION_STRICT"].includes(this.strictType)
    )

    // console.log(this.filedDisable, 'this.filedDisable');
  }

  /**
   * 列表选择请求后端
   */
  checkSuggestMap() {

    // todo 自己是click_url
    if (this.filter.field === 'click_url' && location.pathname.split('/')[2] == 'journey') {

      
      let arr:string[] = []
      for (let i = 0; i < this.filters.length; i++) {
        if ( this.filters[i].field === 'campaign_name') {
          if (typeof(this.filters[i].value) ==='object') {
            for (let j = 0; j < this.filters[i].value.length; j++) {
              arr.push(this.filters[i].value[j] )
            }
          }
        }
        
      }
      // console.log(arr,this.$route.params.id)
      if (arr.length === 1) {
        
          getSuggestList({
            "type": "click_url",
            "emailTemplateType":"CAMPAIGN",
             id:this.$route.params.id,
            "value": arr[0],
        }).then(res => {
          // console.log(res.data.data)
            if(res.data.data.length){
              this.filter.associate = 1
              store.commit('SET_SUGGEST_MAP', {key: this.filter.field, value: res.data.data||[]});
              this.$forceUpdate();
            }
            })
        }
        return
      }



  // if 兄弟有campid  "associate": 1， 清空原有list，请求接口
  //  if 兄弟没有有campid  "associate": 0
    if (!this.filter.field || Object.keys(this.$store.state.suggestMap).indexOf(this.filter.field||'') !== -1) {
      return;
    }
      if (this.newShowVO?.associateId) {
        getContactPropertyDetail({propertyId: this.newShowVO.associateId}).then(res => {
            store.commit('SET_SUGGEST_MAP', {key: this.filter.field, value: res.data.data.valueList||[]});
            this.$forceUpdate();
        })
  
      }else{
        getSuggestList({type: this.filter.field}).then(res => {
            store.commit('SET_SUGGEST_MAP', {key: this.filter.field, value: res.data.data||[]});
            this.$forceUpdate();
        })
  
      }

  }
  /**
   * 条件字段选择
   */
  fieldChange(
    newVal: string | undefined,
    reset = true
  ) {
    for (let showVO of this.fieldOptions) {
      if (showVO.en === newVal) {
        this.newShowVO = showVO
        if (this.newShowVO?.associateId) {
           this.filter.valueType = 'string'
           this.filter.propertyStrictType = "CUSTOM_PROPERTY"
           this.filter.propertyId = this.newShowVO.associateId
        }else{
          this.filter.valueType = showVO.type;
          this.filter.propertyStrictType = "DEFAULT_PROPERTY"
        }
        this.filter.associate = showVO.associate
      }
    }
    if (
      reset &&
      this.filter.valueType &&
      this.typeOperators[this.filter.valueType]
    ) {
      this.operateChange(
        this.filter,
        this.typeOperators[this.filter.valueType][0].en
      );
    }
  }

  /**
   * 条件关系选择
   */
  operateChange(filter: RuleFilterVO, en: string | undefined, reset = true) {
    filter.operator = en;
    for (let key of Object.keys(this.operatorDetail)) {
      if (key === en) {
        const operatorVO = this.operatorDetail[key];
        filter.controls = operatorVO.controls;
        this.$parent.$forceUpdate();
      }
    }
    if (reset) {
      filter.value = [];
    }
    if (filter.field === 'click_url') {
      filter.controls === 'MULTI_INPUT'  && this.checkSuggestMap()
    }else{
      filter.controls === 'MULTI_INPUT' && filter.associate === 1 && this.checkSuggestMap();
    }
  }

  deleteCondition() {
    this.$emit("deleteCondition");
  }
}
